import { useQuery } from '@tanstack/react-query';
import { goodsService, type GoodsOptionsPricingRequest } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useFixedCouponSno } from '../../../hooks/useFixedCouponSno';
import { queryKey } from '../../../constant/queryKey';
import { useIsAnonymousUser } from 'shared/src/hooks';

export const useGoodsOptionsPricing = (body: GoodsOptionsPricingRequest) => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  const isAnonymousUser = useIsAnonymousUser();

  const bodyWithCoupon = {
    ...body,
    fixed_coupon_sno: fixedCouponSno,
  };

  return useQuery({
    queryKey: queryKey.goodsOptionsPricing(goodsSno, bodyWithCoupon),
    queryFn: () =>
      goodsService.postGoodsOptionsPricing(goodsSno, bodyWithCoupon),
    enabled: body.options.length > 0 && !isAnonymousUser,
  });
};
